export default __webpack_public_path__ + "static/media/home.a1e89d38.png";